import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from './pageModule.js'
import preload from 'components/enhancer/preload'
import composeHOC from 'shared/utils/composeHOC'
import Meta from 'components/layout/Meta';
import classnames from 'classnames';

class SinglePage extends Component {
  state = {
    title:'关于我们'
  }
  componentDidMount(){
    $('.companyIntroduction').on('click', '.cooperation-mark li', function() {
      var introduction=$(this).parent().next('.cooperation-introduction')
      var mark=$(this).parent().siblings('.cooperation-mark')
      mark.find('li').removeClass('choose')
      introduction.siblings('.cooperation-introduction').find('li').removeClass('show')
      $(this).addClass('choose').siblings().removeClass('choose')
      introduction.find('li').eq($(this).index()).addClass('show').siblings().removeClass('show')
    })
  }
  render() {
    const {page, route} = this.props

    const menuList = [
      {
        content:'公司介绍',
        link:'company'
      },
      {
        content:'股东介绍',
        link:'shareholder'
      },
      {
        content:'高管团队',
        link:'management'
      },
      {
        content:'公司荣誉',
        link:'honor'
      },
      {
        content:'社会责任',
        link:'responsibility'
      },
    ];

    let routerPathname= this.props.router.location.pathname.split('/')[2]

    return(
      <div className="companyIntroduction about_con">
        <Meta  location={this.props.location} title={route.title}/>
        <div className="about_banner">
          <h3>关于我们</h3>
        </div>
        <div className="about_main">
          <ul className="about_nav">
            {
              menuList.map((item, idx )=> {
                return(
                  <li key={idx} className={classnames({'cur': routerPathname == item.link})}>
                    <a href={'/aboutUs/' + item.link }>{item.content}</a>
                  </li>
                )
              })
            }
          </ul>
          <div className="mgauto">
            <h3 className="cont_h3">
              <span>{page && page.title}</span>
              <p>{page && page.subtitle}</p>
            </h3>
            <div dangerouslySetInnerHTML={{__html: page && page.content}}>
            </div>
          </div>

        </div>

      </div>
    )
  }
}


export default composeHOC(
  connect(state => ({
    page: state.common.page
  }), {
  }),
  preload(({dispatch, location, routes}) => {
    const lastRoute = routes[routes.length - 1]
    const catname = lastRoute.catname || lastRoute.path
    return Promise.all([
      dispatch(actions.getPageContent(catname))
    ])
  })
)(SinglePage)



// WEBPACK FOOTER //
// ./components/page/SinglePage.js